import { ApolloClient, InMemoryCache, createHttpLink, defaultDataIdFromObject } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';

const httpLink = createHttpLink({
  uri: import.meta.env.VITE_API_URL + '/graphql'
});

// const errorLink = onError(({ graphQLErrors, networkError }) => {
//   const error: any = new Error(graphQLErrors?.[0]?.message || networkError?.message || 'Graphql error');
//   error.graphQLErrors = graphQLErrors;
//   error.networkError = networkError;
//   throw error;
// });

const authLink = setContext((_, { headers }) => {
  // Get the authentication token from localStorage if it exists
  const token = localStorage.getItem('authToken');
  
  // Return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  }
});

// Initialize Apollo Client
const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    dataIdFromObject(object) {
      if (object.__typename === 'SupplierProductVariation') {
        return object.sku;
      }

      return defaultDataIdFromObject(object);
    },
  }),
});

export default client;